import { render, staticRenderFns } from "./SignatoryRemoveDialog.vue?vue&type=template&id=332715a8&scoped=true"
import script from "./SignatoryRemoveDialog.vue?vue&type=script&lang=js"
export * from "./SignatoryRemoveDialog.vue?vue&type=script&lang=js"
import style0 from "./SignatoryRemoveDialog.vue?vue&type=style&index=0&id=332715a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332715a8",
  null
  
)

export default component.exports